document.addEventListener('DOMContentLoaded', function () {

  const mainImage = document.querySelector('.main-product-image');

  document.querySelectorAll('.thumb-item').forEach(function (thumb) {

    thumb.addEventListener('click', function () {

      const imageUrl = this.getAttribute('data-image');

      mainImage.setAttribute('src', imageUrl);
      mainImage.setAttribute('srcset', '');

      document.querySelectorAll('.thumb-item').forEach(function (item) {
        item.classList.remove('active');
      });

      this.classList.add('active');

    });

  });

});